<div class="hero">
  <div class="hero__title flex jc-c">
    <h1>Booking Confirmed</h1>
    <img src="../../../assets/img/highlight.svg" alt="Yellow Highlighted Line">
  </div>
  <div *ngIf="isSuccessOpen" class="hero__success">
    <p>You have confirmed your booking successfully!</p>
    <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" viewBox="0 0 40.02 40.02">
      <g data-name="Layer 4">
        <circle cx="20.01" cy="20.01" r="20.01" fill="#fff"/>
        <path fill="#16a577" d="m9.14 17.61-2.5 3.46 8.57 8.47 15.68-15.8-2.69-3.64-13.28 13.28-5.78-5.77z"/>
      </g>
    </svg>
    <svg (click)="isSuccessOpen = !isSuccessOpen" class="hero__success--close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#8fddc4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
      <path d="M18 6 6 18M6 6l12 12"/>
    </svg>
  </div>
  <div class="hero__info">
    <ul class="info__list">
      <li class="info__item">Confirmation email sent to<br>
        <span class="--bold">{{ guestEmail }}</span>
      </li>
      <li class="info__item">Reservation number<br>
        <span class="--bold">{{getOfferInfo().hotel.id.toString().padStart(6, '0')}} -
          {{offerId.toString().padStart(6, '0')}}</span>
      </li>
      <li class="info__item--button">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.5127 19.7603H19.5127C19.7779 19.7603 20.0323 19.8657 20.2198 20.0532C20.4073 20.2408 20.5127 20.4951 20.5127 20.7603C20.5127 21.0256 20.4073 21.2799 20.2198 21.4675C20.0323 21.655 19.7779 21.7603 19.5127 21.7603H5.5127C5.24748 21.7603 4.99313 21.655 4.80559 21.4675C4.61805 21.2799 4.5127 21.0256 4.5127 20.7603C4.5127 20.4951 4.61805 20.2408 4.80559 20.0532C4.99313 19.8657 5.24748 19.7603 5.5127 19.7603ZM13.5127 13.9353L16.7557 10.6933L18.1697 12.1073L12.5127 17.7643L6.8557 12.1073L8.2697 10.6933L11.5127 13.9353V2.76035H13.5127V13.9353Z"
                fill="#10416F" />
        </svg>

        Save as PDF
      </li>
    </ul>
  </div>
</div>

<div class="details">
  <app-booking-info [type]="'voucher'" [facilities]="getFacilitiesTab()" [languages]="getLanguages()" [checkinInfo]="getCheckin()" [pricingPolicy]="getPricingPolicy()"
                    [bookingRequest]="this.bookingContainer.requestForSearch" [hotelInfo]="getHotelInfo()" [mapInformation]="getMapInfo()" [guestDeatailsDisabled]="true"
                    [guestDetails]="getGuestDetails()" [rooms]="getSelectedRooms()"></app-booking-info>
</div>

<div id="voucher-content" class="thanks">
  <div class="thanks__container flex-col jc-c ai-c gap-2">
    <div class="thanks__text">
      <img class="thanks__logo" src="../../../../assets/img/icons/vervendo_symbol_white.svg" alt="White Vervendo Logo">
      <div>
        <h5>Thank you for trusting <span class="--hl-text">Vervendo</span> to book your vacation!</h5>
        <p class="--l-blue">We are happy to help you in any part of your accommodation, along with your host, to make sure you are completely satisfied.
        </p>
      </div>
    </div>
    <!-- <div class="propertyTitle" *ngIf="getHotelInfo()">
        {{getHotelInfo().title}}
        <span>{{getHotelInfo().location}}</span>
      </div> -->
    <div class="thanks__msg">
      <h5>Tell us more about yourself.</h5>
      <p class="--l-blue">Share with your host anything that will further ensure the best accommodation for you.</p>
      <div>
        <form class="thanks__form">
          <textarea cols="5" #messageArea placeholder="Message your host" required=""></textarea>
          <input (click)="sendMessage(messageArea.value)" type="submit" value="Send message">
        </form>
      </div>
    </div>
  </div>
</div>



<!-- <div id="voucher" class="booking confirmation voucher" [hidden]="!printableVoucherEnabled">
  <div id="voucherWrap" class="singleHotel">
    <div id="voucherContentWrap">
      <div id="voucherHeader">
        <img src="../../../../assets/img/vrvnd_logo.svg" style="background-color:#d3d2d2;" alt="Vervendo logo" height="49" width="216">
        <div id="voucherHeaderSorting" class="clear">
          <div class="voucherReservation">
            <div class="wrap clear">
              <div class="reservationNum">
                <div *ngIf="getOfferInfo()">
                  Reservation number
                  <span>{{getOfferInfo().hotel.id.toString().padStart(6, '0')}} -
                    {{offerId.toString().padStart(6, '0')}}</span>
                </div>
              </div>
              <div class="bookingConfirm">
                Booking Confirmation
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="voucherContent">
        <app-booking-info [type]="'voucher'" [facilities]="getFacilitiesTab()" [languages]="getLanguages()" [checkinInfo]="getCheckin()" [pricingPolicy]="getPricingPolicy()"
                          [bookingRequest]="this.bookingContainer.requestForSearch" [hotelInfo]="getHotelInfo()" [rooms]="getSelectedRooms()"></app-booking-info>
      </div>
    </div>
  </div>
  <footer>
    <div id="voucherCopyright">Copyright 2021 &copy; Vervendo</div>
  </footer>
</div> -->